import { render, staticRenderFns } from "./PlacementsGroups.vue?vue&type=template&id=151cd91e"
import script from "./PlacementsGroups.vue?vue&type=script&lang=js"
export * from "./PlacementsGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports